import React from 'react';
import PropTypes from 'prop-types';
import NodeCookies from 'cookies';
import { useRouter } from 'next/router';
import { getPage } from 'lib/api';
import PageTemplate from 'lib/template';
import isEmpty from 'lodash.isempty';
import ErrorHandle from './_error';

function Slug(context) {
  const { page, pageMeta, preview, siteName, sitesettings, extraPageProps } = context;
  const router = useRouter();
  if (!page) {
    const { errorContent } = context;
    return <ErrorHandle statusCode={404} errorContent={errorContent} />;
  }

  return router.isFallback ? (
    <h1>Loading...</h1>
  ) : (
    <PageTemplate
      page={page}
      siteName={siteName}
      pageMeta={pageMeta}
      showWizard={sitesettings.showWizard}
      preview={preview}
      {...extraPageProps}
    />
  );
}

Slug.defaultProps = {
  preview: null,
  page: null,
  pageMeta: null,
  errorContent: {},
  extraPageProps: {},
  siteName: '',
  sitesettings: {
    showWizard: true,
  },
};

Slug.propTypes = {
  page: PropTypes.shape({}),
  pageMeta: PropTypes.shape({}),
  preview: PropTypes.shape({}),
  errorContent: PropTypes.shape({}),
  extraPageProps: PropTypes.shape({}),
  siteName: PropTypes.string,
  sitesettings: PropTypes.shape({
    showWizard: PropTypes.bool,
  }),
};

export async function getServerSideProps(context) {
  const { req, res } = context;
  const cookies = new NodeCookies(req, res);
  const locationCookie = cookies.get('sfnUserLocation');
  let userLocation = null;

  if (isEmpty(locationCookie)) {
    userLocation = { name: 'Amsterdam', lat: 52.37403, lon: 4.88969, noCookie: true };
  } else {
    userLocation = JSON.parse(locationCookie);
  }

  const props = await getPage(context, userLocation);
  const getQuery = `/${context.query.slug.join('/')}`;

  props.redirects.map((redirect) => {
    if (redirect.oldPath === getQuery) {
      const location = redirect.redirectPath || redirect.redirectLink;
      res.setHeader('location', location);
      res.statusCode = redirect.isPermanent ? 301 : 302;
      res.end();
      return { props: {} };
    }
    return null;
  });

  if (!props) {
    return { props: {} };
  }

  return {
    props,
  };
}

export default Slug;
